import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/admin" /> : <Login />} />
      <Route path="/admin/*" element={isAuthenticated ? <AdminDashboard /> : <Navigate to="/login" />} />
      <Route path="/" element={<Navigate to={isAuthenticated ? '/admin' : '/login'} />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
